import { useCart } from 'lib/core/hooks'
import { useEffect } from 'react'

export const useJustunoCart = () => {
  const { count, cart } = useCart()

  useEffect(() => {
    // @ts-expect-error
    const juapp: any = window.juapp
    const cartData = cart?.data

    if (!cartData || !juapp) {
      return
    }

    const { amount: shippingAmount } = cartData.shippingAddress?.selectedShippingMethod ?? {}

    cartData.items.forEach(cartItem => {
      juapp(
        'cartItems',
        [
          {
            productid: cartItem.id,
            // variationid: '[item 1 variation id]',
            sku: cartItem.product.sku,
            quantity: cartItem.quantity,
            price: cartItem.prices.price.value,
            name: cartItem.product.name
            // color: '[item 1 color]',
            // size: '[item 1 size]'
          }
        ]
      )
    })

    juapp(
      'cart',
      {
        total: cartData.prices.grandTotal.value,
        subtotal: cartData.prices.subtotalIncludingTax.value,
        tax: cartData.prices.subtotalIncludingTax.value - cartData.prices.subtotalExcludingTax.value,
        shipping: shippingAmount,
        currency: cartData.prices.grandTotal.currency
      }
    )
    // eslint-disable-next-line
  }, [count])

  return null
}
